import { render, staticRenderFns } from "./QuillEditor.vue?vue&type=template&id=3a6fedcf"
import script from "./QuillEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./QuillEditor.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports